
export const getAppVersion = ()=> {
    return '0.6.112';
};


// WEBPACK FOOTER //
// ./src/version.js